import React, { useEffect } from "react";
import Breadcrumbs from "../../../customComponent/BreadCrumbs";
import {
  FORM_STATUS_STYLES,
  ImageBaseUrl,
  breadcrumbNameMap,
} from "../../../utils/helperData";
import { AiOutlineDownload } from "react-icons/ai";
import { FaArrowLeft } from "react-icons/fa6";
import { useLocation, useNavigate, useParams } from "react-router";
import { VIEW_MANAGE_PROJECT_DETAILS } from "../../../utils/RouteConstant";
import FormSection from "../../../customComponent/FormSection/FormSection";
import FormField from "../../../customComponent/FormField/FormField";
import { useDispatch, useSelector } from "react-redux";
import { GetWeldingGasDetails } from "../../../../redux/action/InspectionDetails/InspectionDetailsAction";
import frame_Icon from "../../../../asesst/file_image.png";

const ViewDetailsWeldingGas = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { inspectionDetaildata } = useSelector(
    (state) => state.inspectionDetails
  );
  const projectDetails = useSelector((state) => state.project.projectDetails);
  console.log("inssdfvfdsdfgfd", inspectionDetaildata);
  useEffect(() => {
    if (location.state?.data?._id) {
      dispatch(GetWeldingGasDetails(location.state.data._id));
    }
  }, [dispatch, location.state?.data?._id]);

  const handleGoBack = () => {
    navigate(
      `${VIEW_MANAGE_PROJECT_DETAILS}/${inspectionDetaildata?.project_id}`,
      {
        state: {
          selectedTab: "Inspection Details",
          selectedInspectionIndex: 1,
        },
        replace: true,
      }
    );
  };

  const baseUrl = ImageBaseUrl;
  const handleDownload = (e, fileUrl, fileName) => {
    e.preventDefault();
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => alert("An error occurred while downloading the file."));
  };
  const truncateString = (str) => {
    if (str?.length > 15) {
      return str.slice(0, 15) + "...";
    }
    return str;
  };

  const renderDocumentSection = () => {
    const { document } = inspectionDetaildata || {};

    if (!document || document.length === 0) return null;

    const renderDocumentItem = (doc, index) => (
      <div
        key={index}
        className="flex items-center justify-between p-4 border border-gray-200 rounded-lg"
      >
        <div className="flex items-center space-x-3">
          <img
            src={frame_Icon}
            alt="Inspector Document"
            className="w-12 h-12 rounded-lg"
          />
          <div>
            <p className="font-semibold">
              {truncateString(doc.name || "Document")}
            </p>
          </div>
        </div>
        <button
          className="text-[#1C3664]"
          onClick={(e) => handleDownload(e, `${baseUrl}${doc}`, doc)}
        >
          <AiOutlineDownload size={24} />
        </button>
      </div>
    );

    return <FormSection>{document.map(renderDocumentItem)}</FormSection>;
  };

  return (
    <div>
      <div className=" mb-6">
        <h2 className="text-3xl font-bold mb-6">Welding Gas Certification</h2>
        <div className="flex justify-between items-center">
          <Breadcrumbs breadcrumbNameMap={breadcrumbNameMap} />
          <div className="flex gap-2 items-center">
            {projectDetails?.document && (
              <img
                src={`${ImageBaseUrl}${projectDetails.document}`}
                alt="not"
                className="preview-image w-[3.5rem] h-12 bg-cover bg-center rounded-3xl mr-2.5"
              />
            )}
            <span className="text-xl font-semibold">
              Project Name:-
              <span className="text-blue-500">
                {" "}
                {projectDetails?.name || location?.state?.data?.project_name}
              </span>
            </span>
          </div>
        </div>
      </div>
      <div className="mx-auto bg-white shadow-lg rounded-lg p-8">
        <div className="flex items-center text-2xl font-base font-poppins mb-8 text-[#202224]">
          <FaArrowLeft className="cursor-pointer" onClick={handleGoBack} />
          <h3
            className="text-lg p-2 font-semibold cursor-pointer"
            onClick={handleGoBack}
          >
            Go Back{" "}
          </h3>
        </div>
        <FormSection title="Inspection Data">
          <FormField
            label="Inspection Location"
            value={inspectionDetaildata?.locName?.name}
          />
          <FormField
            label="Inspection Date"
            value={
              inspectionDetaildata?.ins_date
                ? new Date(inspectionDetaildata?.ins_date).toLocaleDateString(
                    "en-US",
                    {
                      month: "2-digit",
                      day: "2-digit",
                      year: "numeric",
                    }
                  )
                : "-"
            }
          />
          <FormField
            label="Acceptance Criteria"
            value={inspectionDetaildata?.accept_criteria}
          />
          <FormField
            label="Lot/Serial Number"
            value={inspectionDetaildata?.number}
          />
          <FormField
            label="NCR Genrated"
            value={inspectionDetaildata?.ncr ? "True" : "False"}
          />
          {/* <FormField
            label="Reference Number"
            value={inspectionDetaildata?.ref_no}
          /> */}
          <FormField
            label="Status"
            value={
              FORM_STATUS_STYLES[inspectionDetaildata?.form_status]?.label ||
              "-"
            }
          />
        </FormSection>
        {renderDocumentSection()}
      </div>
    </div>
  );
};

export default ViewDetailsWeldingGas;
